import Random from './random'

let uuid
if (!uuid) {
  uuid = Random.id(32, 62)
}

export default uuid
